import {
  LOGIN_REQUEST,
  FORGOT_PASSWORD,
  RESEND_VERIFICATION_EMAIL,
  BUSINESS_STARTS_REQUEST,
  BUSINESS_SALES_REQUEST,
  LOAD_RESET_PASSWORD,
  SEND_RESET_PASSWORD,
  LOAD_PREPARE_ENCRYPTION,
  SET_PREPARE_ENCRYPTION,
  GENERATE_OTP,
} from './constant-mess';

/**
 * Tells the app we want to log in a user
 * @param  {object} data          The data we're sending for log in
 * @param next
 * @param  {string} data.email The username of the user to log in
 * @param  {string} data.password The password of the user to log in
 */
export function loginRequest(data, next = null) {
  return { type: LOGIN_REQUEST, payload: { data, next } };
}

export function resendVerificationEmail(data) {
  return { type: RESEND_VERIFICATION_EMAIL, payload: { data } };
}

export function forgotPassword(data) {
  return { type: FORGOT_PASSWORD, payload: { data } };
}

export function generateOtpRequest(data) {
  return { type: GENERATE_OTP, payload: { data } };
}

export function businessStarts() {
  return { type: BUSINESS_STARTS_REQUEST };
}

export function businessSales() {
  return { type: BUSINESS_SALES_REQUEST };
}

export function loadResetPassword(data) {
  return { type: LOAD_RESET_PASSWORD, payload: { token: data } };
}

export function resetPassword(data, token) {
  return { type: SEND_RESET_PASSWORD, payload: { data, access_token: token } };
}

export function loadPrepareEncryption() {
  return { type: LOAD_PREPARE_ENCRYPTION };
}

export function setPrepareEncryption(data) {
  return {
    type: SET_PREPARE_ENCRYPTION,
    payload: {
      encryption: {
        public_modulus: data.responseData.public_modulus,
        public_exponent: data.responseData.public_exponent,
        key: data.responseData.public_exponent,
      },
    },
  };
}
